import { styled } from 'styled-components';

import { SearchItem, StyledTypography } from '../index';
import Highlight from './Highlight';

interface Props {
  inputValue: string;
  item: SearchItem;
  handleItemClick: (item: SearchItem) => void;
}

const SearchResultItem: React.FC<Props> = ({
  inputValue,
  item,
  handleItemClick,
}) => {
  const startIndex = item.name.toLowerCase().indexOf(inputValue.toLowerCase());
  const endIndex = startIndex + inputValue.length;
  return (
    <Result
      onMouseDown={() => {
        handleItemClick(item);
      }}
      key={item.name}
      tabIndex={0}
    >
      <StyledTypography
        variant="paragraph-large"
        color={'var(--color-shade-80)'}
      >
        {item.name.substring(0, startIndex)}
        <Highlight text={item.name.substring(startIndex, endIndex)} />
        {item.name.substring(endIndex, item.name.length)}
      </StyledTypography>
    </Result>
  );
};

export default SearchResultItem;

export const Result = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;

  :focus {
    background-color: var(--color-shade-30);
    outline-width: 0;
  }

  &:hover {
    background-color: var(--color-shade-30);
  }
`;
